import { Chart } from "@appretio/ui-kit";
import type { ForecastMetaDataType } from "../../hooks/useFetchForecastMetaData";
import type { ForecastTableControlValues } from "../tableControls/forecastTableControlValues";
import { useEventCalendarOptions } from "./hooks/useEventCalendarOptions";
import { useFetchEventChartData } from "./hooks/useFetchEventChartData";

interface EventCalendarProps {
  /** Forecast metadata for period-label mapping. */
  metaData: ForecastMetaDataType | undefined;
  /** Time-period granularity from the forecast table controls. */
  timePeriod: ForecastTableControlValues["timePeriod"];
  /** Weekly time-axis labels: calendar (via ``gregMapping``) or fiscal keys. */
  weekLabels: ForecastTableControlValues["weekLabels"];
}

export function EventCalendar({
  metaData,
  timePeriod,
  weekLabels
}: EventCalendarProps) {
  const { data: events, isFetching } = useFetchEventChartData(true);
  const chartOptions = useEventCalendarOptions(
    events,
    metaData,
    timePeriod,
    weekLabels
  );
  return <Chart options={chartOptions} isLoading={isFetching} />;
}
